/** i18n setup — react-i18next + 3 locales. */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./messages/en.json";
import ru from "./messages/ru.json";
import uz from "./messages/uz.json";

const STORAGE_KEY = "ri-admin-locale";
const DEFAULT_LOCALE = "ru";

const stored = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;

void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    uz: { translation: uz },
    en: { translation: en },
  },
  lng: stored ?? DEFAULT_LOCALE,
  fallbackLng: "ru",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLocale(lang: "ru" | "uz" | "en"): void {
  i18n.changeLanguage(lang);
  localStorage.setItem(STORAGE_KEY, lang);
}

export default i18n;
